import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const submitDescriptionEntries = createAsyncThunk(
    "entriesDescription/submitDescriptionEntries",
    async (Payload, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "/descriptiontask/replace-before-assigned",
                Payload
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const submitWorkEntries = createAsyncThunk(
    "entriesDescription/submitWorkEntries",
    async (Payload, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                "/workentries/replace-before-assigned",
                Payload
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const entriesDescriptionSlice = createSlice({
    name: "entriesDescription",
    initialState: {
        descriptionStatus: "idle", // idle | loading | succeeded | failed
        workStatus: "idle",
        descriptionError: null,
        workError: null,
        descriptionResponse: null,
        workResponse: null,
    },
    reducers: {
        resetEntriesDescriptionState: (state) => {
            state.descriptionStatus = "idle";
            state.workStatus = "idle";
            state.descriptionError = null;
            state.workError = null;
            state.descriptionResponse = null;
            state.workResponse = null;
        },
    },
    extraReducers: (builder) => {
        builder

        .addCase(submitDescriptionEntries.pending, (state) => {
                state.descriptionStatus = "loading";
            })
            .addCase(submitDescriptionEntries.fulfilled, (state, action) => {
                state.descriptionStatus = "succeeded";
                state.descriptionResponse = action.payload;
            })
            .addCase(submitDescriptionEntries.rejected, (state, action) => {
                state.descriptionStatus = "failed";
                state.descriptionError = action.payload;
            })

            .addCase(submitWorkEntries.pending, (state) => {
                state.workStatus = "loading";
            })
            .addCase(submitWorkEntries.fulfilled, (state, action) => {
                state.workStatus = "succeeded";
                state.workResponse = action.payload;
            })
            .addCase(submitWorkEntries.rejected, (state, action) => {
                state.workStatus = "failed";
                state.workError = action.payload;
            });
    },
});

export const { resetEntriesDescriptionState } = entriesDescriptionSlice.actions;
export default entriesDescriptionSlice.reducer;
